import { useState, useContext, useEffect } from 'react';
import { syncCustomer } from '@crossroads/shop-state/customer';
import { useSendMessage } from 'crustate/react';
import { useTranslate } from '@awardit/react-use-translate';
import { useHistory } from 'react-router';
import { addMessage } from '@crossroads/shop-state/messages';
import { parseParams } from './location-search-string.js';
import { parseErrorCode } from './utils.js';

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var useRenderPaymentMethods = _ref => {
  function _temp3() {
    push(t("URL.CHECKOUT_SUCCESS"));
  }

  function _temp2() {
    if (customerQuery !== null && customerQuery !== undefined) {
      return _awaitIgnored(client(customerQuery).then(_temp));
    }
  }

  function _temp(_ref2) {
    var customer = _ref2.customer;
    sendMessage(syncCustomer(customer));
  }

  var token = _ref.token,
      sessionId = _ref.sessionId,
      setPaymentSelected = _ref.setPaymentSelected,
      client = _ref.client,
      customerQuery = _ref.customerQuery,
      storeInfoContext = _ref.storeInfoContext;
  var t = useTranslate();

  var _useState = useState(true),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useHistory = useHistory(),
      push = _useHistory.push;

  var sendMessage = useSendMessage();

  var _useState2 = useState(false),
      paymentMethodsError = _useState2[0],
      setPaymentMethodsError = _useState2[1];

  var _useState3 = useState(0),
      paymentIndex = _useState3[0],
      setPaymentIndex = _useState3[1];

  var _useContext = useContext(storeInfoContext),
      baseUrl = _useContext.info.baseUrl;

  var checkoutOverviewUrl = t("URL.CHECKOUT_OVERVIEW");
  var formattedCheckoutOverviewUrl = checkoutOverviewUrl.startsWith("/") ? checkoutOverviewUrl.slice(1) : checkoutOverviewUrl;
  var redirectUrl = new URL(formattedCheckoutOverviewUrl, baseUrl).toString();

  var syncStatesAndRedirect = function syncStatesAndRedirect() {
    // Sync new customer data to get the new point balance etc
    return _await(_invoke(_temp2, _temp3));
  };

  var initPaymentMethodSDK = () => {
    var _window$Altapay, _window$Altapay3;

    var _parseParams = parseParams(window.location.search),
        querySessionId = _parseParams.sessionId,
        redirectData = _parseParams.redirectData;

    var sessionToUse = querySessionId || sessionId;
    (_window$Altapay = window.Altapay) == null ? void 0 : _window$Altapay.init(token, sessionToUse).setCallbacks(AltaPayFactory.getCallbacksBuilder().setSuccess(() => {
      syncStatesAndRedirect();
    }).setRedirectUrl(redirectUrl).setFailure(altapayEvent => {
      var listElement = document.getElementById("paymentMethodsList");
      var errorMessage = parseErrorCode(altapayEvent);
      console.log("payment failed callback triggered");
      console.log(altapayEvent);
      setPaymentMethodsError(true);
      setIsLoading(true);
      setPaymentIndex(0);

      if (listElement) {
        listElement.textContent = "";
      }

      sendMessage(addMessage(errorMessage, "error"));
    }).setBodyFormat("JSON").build());

    if (redirectData) {
      var _window$Altapay2;

      (_window$Altapay2 = window.Altapay) == null ? void 0 : _window$Altapay2.handleRedirectData(redirectData);
    }

    (_window$Altapay3 = window.Altapay) == null ? void 0 : _window$Altapay3.onRenderPaymentMethodCallback(onRenderPaymentMethodEvent => {
      var payment = onRenderPaymentMethodEvent.paymentMethod;
      var paymentMethodElement = document.createElement("div");
      paymentMethodElement.className = "payment-item-container";
      paymentMethodElement.id = payment.id;
      paymentMethodElement.dataset.paymentMethod = payment.description;
      var radioInputElement = document.createElement("input");
      radioInputElement.type = "radio";
      radioInputElement.name = "payment-method";
      radioInputElement.value = payment.description;
      var paymentLogoElement = document.createElement("img");
      paymentLogoElement.className = "payment-logo";
      paymentLogoElement.src = payment.logoUrl;
      paymentLogoElement.alt = payment.description;
      var paymentDescriptionElement = document.createElement("span");
      paymentDescriptionElement.className = "payment-description";
      paymentDescriptionElement.textContent = payment.description === "Credit / Debit Card" ? t("PAYMENT_METHODS.ALTAPAY.CARD") : payment.description;
      paymentMethodElement.append(radioInputElement);
      paymentMethodElement.append(paymentLogoElement);
      paymentMethodElement.append(paymentDescriptionElement);

      var onChange = e => {
        var value = e.currentTarget.value;
        radioInputElement.checked = value === payment.description;
        radioInputElement.value = value;
        onRenderPaymentMethodEvent.onSelectPaymentMethodCallback();
      };

      var onClick = () => {
        radioInputElement.checked = true;
        setPaymentSelected(true);
        radioInputElement.dispatchEvent(new Event("change"));
        onRenderPaymentMethodEvent.onSelectPaymentMethodCallback();
      };

      radioInputElement.addEventListener("change", onChange);
      paymentMethodElement.addEventListener("click", onClick);

      if (paymentIndex === 0) {
        paymentMethodElement.click();
      }

      setPaymentIndex(paymentIndex + 1);
      return paymentMethodElement;
    }).injectPaymentMethods(document.getElementById("paymentMethodsList")).then(() => {
      if (paymentMethodsError) {
        setPaymentMethodsError(false);
      }

      setIsLoading(false);
    }).catch(e => {
      console.log(e);
      setPaymentMethodsError(true);
      setIsLoading(true);
    });
  };

  useEffect(() => {
    var loadAltapaySDK = setInterval(() => {
      clearInterval(loadAltapaySDK);

      if (window.Altapay && token && sessionId) {
        initPaymentMethodSDK();
      }
    }, 1000);
  }, [token, sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isLoading,
    paymentMethodsError
  };
};

export { useRenderPaymentMethods };
//# sourceMappingURL=use-render-payment-methods.js.map
